import { HierarcicalObjectReference } from "@novorender/data-js-api";

import { ListNode, Node, Tree } from "components/objectTree/types";

export type ModelTreeFilterObjects = {
    type: ModelTreeFilter;
    objects: HierarcicalObjectReference[];
};

export type ModelTreeNodeData = {
    object: HierarcicalObjectReference;
    childIterator?: AsyncIterableIterator<HierarcicalObjectReference>;
};

export type TreeNodeRendererProps = {
    item: ListNode<ModelTreeNodeData>;
    setLoading: (value: boolean) => void;
    onToggleExpanded: (item: ListNode<ModelTreeNodeData>, node?: Node<ModelTreeNodeData>) => void;
    /**
     * Expands a collapsed group of repeated rows (the "clickable small number" badge).
     */
    onExpandGroup?: (node: ListNode<ModelTreeNodeData>) => void;
    /**
     * Notifies the tree that a main-object selection was initiated from within the tree (e.g.
     * clicking a row), so it can avoid auto-scrolling the selected row to the top. Pass the
     * main-object id being selected.
     */
    onSelectInTree?: (mainObjectId: number | undefined) => void;
    onNodeRightClick?: (x: number, y: number, item: ListNode<ModelTreeNodeData>) => void;
    abortSignal: AbortSignal;
    highlightPath?: string;
    tree: Tree<ModelTreeNodeData>;
    filteredObjectIds?: Set<number> | null;
    searchTerm?: string;
};

export enum ModelTreeFilterType {
    ParserType,
    Terrain,
}
export type ModelTreeFilter =
    | { type: ModelTreeFilterType.Terrain }
    | { type: ModelTreeFilterType.ParserType; parserType: string };
